import { Pipe, PipeTransform } from '@angular/core';
import { TIME_SHORT_FORMAT, EMPTY_TIME_PLACEHOLDER } from '../constants/date-config';
import { addMinutes, format, startOfDay } from 'date-fns';

@Pipe({
    name: 'minutesToHours',
    standalone: false
})
export class MinutesToHoursPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) {
      return EMPTY_TIME_PLACEHOLDER;
    }

    const startDay = startOfDay(new Date());
    const dateWithAddedMinutes = addMinutes(startDay, value);

    return format(dateWithAddedMinutes, TIME_SHORT_FORMAT);
  }
}
